import React from 'react';
import ProfileEditorUserAvatar from '../ProfileEditorUserAvatar';
import EditRoleDescription from './EditRoleDescription';
import EditRoleSummary from './EditRoleSummary';
import GeneralInfo from './GeneralInfo';

export default function Overview() {
	return (
		<div className="overview">
			<div className="top-row">
				<ProfileEditorUserAvatar />
				<GeneralInfo />
			</div>
			<EditRoleSummary />
			<EditRoleDescription />
		</div>
	);
}
